import React, { ReactElement } from 'react';
import { Col, Row } from 'reactstrap';
import Tabs from '../../../../../components/HearingAndAppealTabs/HearingAndAppealTabs.component';
import { HEARING_TABS } from '../../../../../utils/case-utils';
import { Formik, FormikErrors, FormikProps, FormikValues, getIn } from 'formik';
import {
  filterFormData,
  getFormDataFromCaseData,
  WorkflowComponentProps,
} from '../../../../WorkflowContainer/workflow-utils';
import { WorkFlowFooter } from '../../../../../components/workflowFooter/WorkFlowFooter';
import { CaseType, TemplateType } from '../../../../../API';
import { DocumentVersionControlTable } from '../../../../../components/documentVersionControlTable/DocumentVersionControlTable';
import { Tooltip } from '../../../../../components/tooltips/Tooltip.component';
import { getFieldsAndValidationSchema } from '../../hearing-utils';
import { AppealHearingConfirmOverallSanctionForm } from './AppealHearingConfirmOverallSanctionForm';
import { AppealHearingPoorPerformanceConfirmOverallSanctionForm } from './AppealHearingPoorPerformanceConfirmOverallSanctionForm';

export const AppealHearingConfirmOverallSanction: React.FC<WorkflowComponentProps> = (
  props: WorkflowComponentProps,
) => {
  const { caseData, flowableFunctions } = props.data;
  const setupValues = getFieldsAndValidationSchema(props.data.caseType, props.data.flowableFunctions.formKey);
  const { fields, validationSchema } = setupValues;
  const initialValues = getFormDataFromCaseData(fields, caseData);

  console.log('Ctestign init values:', initialValues);

  const getChairpersonsRuling = (): string[] => {
    const docs = props.data.caseData.appeal_hearing_chairpersonsRulingDocuments;
    console.log('props.data.caseData.isAppeal: ', props.data.caseData.isAppeal);
    console.log('docs: ', docs);
    if (!docs) {
      throw new Error('No chairpersons ruling');
    }
    return docs.map(d => d.key);
  };

  const getTemplateType = (): TemplateType => {
    if (props.data.caseType === CaseType.MISCONDUCT) {
      return TemplateType.HEARING_OUTCOME_MISCONDUCT_APPEAL;
    } else if (props.data.caseType === CaseType.POOR_PERFORMANCE) {
      return TemplateType.HEARING_OUTCOME_POOR_PERFORMANCE_APPEAL;
    } else throw new Error('Invalid case type');
  };

  const renderForm = (): JSX.Element => {
    switch (props.data.caseType) {
      case CaseType.MISCONDUCT:
        return <AppealHearingConfirmOverallSanctionForm />;
      case CaseType.POOR_PERFORMANCE:
        return <AppealHearingPoorPerformanceConfirmOverallSanctionForm data={props.data} />;
    }
    return <> </>;
  };

  const submitValues = (values: FormikValues): void => {
    const formValues = { ...values };
    if (props.data.caseType === CaseType.MISCONDUCT) {
      formValues.incidents = JSON.stringify(values.incidents);
    } else if (props.data.caseType === CaseType.POOR_PERFORMANCE) {
      formValues.performanceShortfalls = JSON.stringify(values.performanceShortfalls);
    }

    flowableFunctions.onNext(filterFormData(formValues, fields), values.revisedOverallSanction === '');
  };

  const setErrors = (
    errors: FormikErrors<FormikValues>,
    setFieldTouched: (field: string, touched: boolean) => void,
  ): void => {
    const errorKeys = Object.keys(errors);
    errorKeys.forEach(field => {
      //if fieldArray
      if (Array.isArray(errors[field])) {
        const err = getIn(errors, field);
        const innerArr = Object.keys(err);
        innerArr.forEach((item, index) => {
          let fieldNames;
          if (err[item]) {
            fieldNames = Object.keys(err[item]);
            fieldNames.forEach(name => setFieldTouched(`${field}.${index}.${name}`, true));
          }
        });
      } else {
        setFieldTouched(field, true);
      }
    });
  };

  return (
    <div className="content">
      <h4 className="text-h4 text-capitalize font-weight-500 mt-33">
        Conclude {props.data.caseData.isAppeal && 'Appeal'} Hearing
      </h4>
      <Row>
        <Col md={12}>
          <Tabs page={8} tabs={HEARING_TABS} />
        </Col>
      </Row>
      <h5 className="text-h5 text-blue text-capitalize font-weight-500 mt-3">
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        Chairperson's Ruling
        <span className="ml-3">
          <Tooltip
            title={"Chairperson's Ruling"}
            id="appeal_hearing_chairpersonsRuling"
            text={`Based on the Chairperson’s ruling, capture below the findings on guilt and sanction as applicable.`}
          />
        </span>
      </h5>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={submitValues}
        validationSchema={validationSchema}
      >
        {({ values, handleSubmit, errors, setFieldTouched }: FormikProps<FormikValues>): ReactElement => (
          <>
            {renderForm()}
            {props.data.caseData.isAppeal && (
              <>
                <button
                  className="btn prepare-letter-button mb-3"
                  disabled={!!Object.keys(errors).length}
                  onClick={(): void => {
                    props.data.flowableFunctions.onOpenNewDocument(values, fields, getTemplateType());
                  }}
                >
                  PREPARE APPEAL OUTCOME LETTER
                </button>

                {props.data.processInstanceId ? (
                  <DocumentVersionControlTable
                    data={props.data}
                    processInstanceId={props.data.processInstanceId}
                    templateType={getTemplateType()!}
                    completeTask={props.data.flowableFunctions.completeTask}
                    additionalAttachmentFormKeys={getChairpersonsRuling()}
                  />
                ) : null}
              </>
            )}
            {/*<pre>{JSON.stringify(values, null, 2)}</pre>*/}
            <WorkFlowFooter
              data={props.data}
              // finalPage={values.revisedOverallSanction === 'NOT_APPLICABLE'}
              onNext={(): void => {
                setErrors(errors, setFieldTouched);
                if (!Object.keys(errors).length) handleSubmit();
              }}
              onCancel={(): void => console.log('cancel')}
              onSaveAndClose={(): void => {
                props.data.flowableFunctions.onSaveAndClose(values);
              }}
            />
          </>
        )}
      </Formik>
    </div>
  );
};
